<!--首页模块一-->
<template>
  <div style="font-family:Alibaba">
    <!-- PC端-->
    <!--零碳海洋-->
    <div class='title'>
      <div>
        <h1>
          <i class="el-icon-caret-right"></i>{{ cnNameOne }}
        </h1>
        <p>{{ enNameOne }}</p>
      </div>
    </div>
    <!--零碳海洋-->
    <el-row :span="24" class="box-width carbon background_img">
      <a href="#" class='card_box' @click='handleOneClick()'>
        <el-col :md="12" :sm="12" :xs="24">
          <div class="div_img">
            <el-image
              class="carbon_img"
              :fit='fit'
              v-if='homeOneVo.fullPathUrl != null'
              :src='homeOneVo.fullPathUrl'
            />
          </div>
        </el-col>
        <el-col :md="12" :sm="12" :xs="24">
          <div class="text">
            <h4>{{ homeOneVo.title }}</h4>
            <div v-html="homeOneVo.briefIntroduction" class="htmlImgSize" style="color: #606266"></div>
          </div>
        </el-col>
      </a>
    </el-row>
  </div>
</template>
<script>
import {
  findHomeOne, findEnNameOne
} from '@api/zh'

export default {
  created () {
  },
  data () {
    return {
      enNameOne: '',
      cnNameOne: '',
      homeOneVo: {},
      fit: 'cover',
      src: require('@assets/images/index/chanping2.png')
    }
  },
  mounted () {
    this.selectHOne()
  },
  methods: {
    /** 查询英文名称 */
    selectEnName (cnEnNameId) {
      let that = this
      findEnNameOne(cnEnNameId).then(res => {
        let data = res.data
        that.enNameOne = data.enName
        that.cnNameOne = data.cnName
      })
    },
    async selectHOne () {
      let that = this
      await findHomeOne().then(res => {
        if (res.data.cnEnNameId !== null) {
          that.selectEnName(res.data.cnEnNameId)
        }
        that.homeOneVo = res.data
      })
    },
    handleOneClick () {
      const routeData = this.$router.resolve({
        path: this.homeOneVo.linksVo.href,
        query: { tabId: this.homeOneVo.linksVo.id }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped>
::v-deep .htmlImgSize img{
  max-width: 100%;
  height: auto;
}
</style>
